export function mcyStatusChanger(alarmValue?: number) {
  switch (alarmValue) {
    case 0:
    case 1:
    case 2:
      return "normal";
    case 3:
    case 4:
      return "warning";
    case 5:
      return "critical";
    default:
      return "off";
  }
}
